import { render, staticRenderFns } from "./ProfileComponent.vue?vue&type=template&id=4b97cb61&"
import script from "./ProfileComponent.vue?vue&type=script&lang=js&"
export * from "./ProfileComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports